/**
 * 提交方式配置
 * 用于客户资料包相关组件的配置共享
 *
 * 扩展新的提交方式时，只需在此添加配置项即可
 *
 * 注意：此文件只包含基础的配置和配置访问方法
 * 复杂的业务逻辑方法应该放在各自的组件内部
 */

/**
 * 提交方式配置列表
 * @type {Array<{
 *   value: string,
 *   label: string,
 *   dialogLabel?: string,
 *   buttonLabel?: string,
 *   categoryListKey: string,
 *   visible?: Function,
 *   actionHandler?: string
 * }>}
 */
export const submissionMethodsConfig = [
  {
    // 提交方式的唯一标识
    value: "manualUpload",
    // 显示在复选框上的标签
    label: "手工上传附件",
    // 在对话框中显示的标签
    dialogLabel: "手工上传",
    // 在操作按钮上显示的标签
    buttonLabel: "上传",
    // 关联的品类列表字段名
    categoryListKey: "manualUploadCategoryList",
    // 显示规则：返回 true 表示显示该选项
    visible: () => true, // 始终显示
    // 操作按钮的处理方法名
    actionHandler: "handleUpload",
  },
  {
    value: "onlineProcessing",
    label: "电子合同",
    dialogLabel: "电子合同",
    // 客户合同显示为"发起电子合同"，客户合同报价清单仍显示"办理"
    buttonLabel: (row) =>
      row.informationPackTypeCode === "customerContract"
        ? "发起电子合同"
        : "办理",
    categoryListKey: "onlineProcessingCategoryList",
    visible: (row) => {
      return (
        row.informationPackTypeCode === "customerContractQuotationList" ||
        row.informationPackTypeCode === "customerContract"
      );
    },
    actionHandler: "handleProcess",
  },
  {
    value: "contractConfirm",
    label: "纸质合同确认",
    dialogLabel: "纸质合同确认",
    buttonLabel: "纸质合同确认",
    categoryListKey: "contractConfirmCategoryList",
    visible: (row) => {
      return row.informationPackTypeCode === "customerContract";
    },
    actionHandler: "handleContractConfirm",
  },
  // 扩展示例：
  // {
  //   value: "electronicSignature",
  //   label: "电子签名",
  //   dialogLabel: "电子签名",
  //   buttonLabel: "签名",
  //   categoryListKey: "electronicSignatureCategoryList",
  //   visible: (row) => {
  //     return row.informationPackTypeCode === "customerContract";
  //   },
  //   actionHandler: "handleElectronicSignature",
  // },
];

/**
 * 根据 value 获取配置
 * @param {string} value 提交方式的唯一标识
 * @returns {Object|undefined} 配置对象
 */
export function getConfigByValue(value) {
  return submissionMethodsConfig.find((config) => config.value === value);
}

/**
 * 获取所有品类列表字段名
 * @returns {Array<string>} 所有品类列表字段名的数组
 */
export function getAllCategoryListKeys() {
  return submissionMethodsConfig
    .map((config) => config.categoryListKey)
    .filter(Boolean);
}

/**
 * 构建提交方式到品类列表字段的映射
 * @returns {Object} 映射对象，格式为 { methodValue: categoryListKey }
 */
export function buildMethodToCategoryKeyMap() {
  const map = {};
  submissionMethodsConfig.forEach((config) => {
    if (config.value && config.categoryListKey) {
      map[config.value] = config.categoryListKey;
    }
  });
  return map;
}

/**
 * 获取行可用的提交方式列表
 * 根据 visible 规则过滤，返回对该行可用的提交方式
 * @param {Object} row 行数据
 * @returns {Array} 可用的提交方式配置列表
 */
export function getAvailableSubmissionMethods(row) {
  return submissionMethodsConfig.filter((method) => {
    if (typeof method.visible === "function") {
      return method.visible(row);
    }
    return true;
  });
}



// WEBPACK FOOTER //
// ./src/components/developerInfo/components/submissionMethodsConfig.js